import { render, staticRenderFns } from "./CasesConfirmation.vue?vue&type=template&id=66d9ab84"
import script from "./CasesConfirmation.vue?vue&type=script&lang=js"
export * from "./CasesConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports